import n from "./component-library45.js";
const a = {
  components: {
    Controls: n
  },
  props: {
    autoplay: { type: Number, default: 5e3 },
    startSlide: { type: Number, default: 0 },
    transitionDuration: { type: Number, default: 400 },
    pauseOnHover: { type: Boolean, default: !0 },
    role: { type: String, default: "region" },
    ariaLabel: { type: String, default: "Slider" },
    ariaLableSlide: { type: String, default: "Slide" }
  },
  data() {
    return {
      activeSliderIndex: this.startSlide,
      timeout: null,
      transitionTimeout: null,
      sliderTransition: this.transitionDuration,
      isMouseOver: !1,
      isPlaying: this.autoplay > 0
    };
  },
  computed: {
    slides() {
      return this.$slots.default ? this.$slots.default.filter((t) => t.tag) : [];
    },
    slideCount() {
      return this.slides.length;
    },
    transform() {
      return `${-100 * this.activeSliderIndex}%`;
    },
    sliderClass() {
      const t = [];
      this.slideCount > 1 && t.push("slider--has-pagination");
      const i = this.slides[this.activeSliderIndex]?.data?.attrs?.["data-slider-class"];
      return i && i.split(" ").forEach((e) => {
        t.push(e);
      }), t;
    },
    sliderStyles() {
      return [
        `--slide-count: ${this.slideCount}`,
        `--slider-transition: ${this.sliderTransition}ms`,
        `--slider-translate: ${this.transform}`,
        this.slides[this.activeSliderIndex]?.data?.attrs?.["data-slider-styles"] || ""
      ].join("; ");
    },
    pages() {
      const t = [];
      for (let i = 0; i < this.slideCount; i += 1)
        t.push({ number: i, active: i === this.activeSliderIndex });
      return t;
    }
  },
  watch: {
    activeSliderIndex(t, i) {
      i !== void 0 && this.slides[i]?.componentInstance && (this.slides[i].componentInstance.isActiveSlide = !1), this.slides[t]?.componentInstance && (this.slides[t].componentInstance.isActiveSlide = !0);
    },
    isPlaying(t) {
      t ? this.startTimeout() : this.timeout && clearTimeout(this.timeout);
    },
    slides: {
      handler() {
        this.setSlideData();
      },
      immediate: !0
    }
  },
  mounted() {
    this.slides[this.activeSliderIndex]?.componentInstance && (this.slides[this.activeSliderIndex].componentInstance.isActiveSlide = !0), !(this.slideCount <= 1) && ((this.activeSliderIndex < 0 || this.activeSliderIndex >= this.slideCount) && (this.activeSliderIndex = 0), this.startTimeout());
  },
  beforeUnmount() {
    this.timeout && clearTimeout(this.timeout), this.transitionTimeout && clearTimeout(this.transitionTimeout);
  },
  methods: {
    focusin(t) {
      const i = t.target;
      if (!i) return;
      const e = i.closest("[slide-no]");
      if (!e || !e.getAttribute("slide-no")) return;
      const s = parseInt(e.getAttribute("slide-no") || "0", 10);
      !Number.isNaN(s) && this.activeSliderIndex !== s && (this.selectSlide(s), setTimeout(() => {
        this.$refs.sliderElement && (this.$refs.sliderElement.scrollLeft = 0);
      }, 400));
    },
    setSlideData() {
      setTimeout(() => {
        this.slides && this.slides.forEach((t, i) => {
          const e = t.elm;
          e?.setAttribute && (e.setAttribute(
            "aria-label",
            `${this.ariaLableSlide} ${i + 1} von ${this.slides.length}`
          ), e.setAttribute("role", "group"), e.setAttribute("slide-no", String(i)));
        });
      }, 1);
    },
    animateSlides(t) {
      this.transitionTimeout && clearTimeout(this.transitionTimeout), Math.abs(this.activeSliderIndex - t) === 1 ? this.sliderTransition = this.transitionDuration : this.sliderTransition = this.transitionDuration * 2, this.activeSliderIndex = Math.min(t, this.slideCount - 1), this.transitionTimeout = setTimeout(() => {
        this.startTimeout();
      }, this.transitionDuration);
    },
    selectSlide(t) {
      t !== this.activeSliderIndex && this.animateSlides(t);
    },
    changeSlide(t) {
      const i = (this.activeSliderIndex + t + this.slideCount) % this.slideCount;
      this.animateSlides(i);
    },
    startTimeout() {
      this.isPlaying && (this.isMouseOver && this.pauseOnHover || (this.timeout && clearTimeout(this.timeout), this.slideCount > 1 && this.autoplay > 0 && (this.timeout = setTimeout(() => this.changeSlide(1), this.autoplay))));
    },
    hoverEnter() {
      this.isMouseOver = !0, this.pauseOnHover && this.isPlaying && this.timeout && clearTimeout(this.timeout);
    },
    hoverLeave() {
      this.isMouseOver = !1, this.pauseOnHover && this.isPlaying && (this.timeout && clearTimeout(this.timeout), this.startTimeout());
    }
  }
};
export {
  a as default
};
